// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:768px){.potential-workers-table td{flex-direction:column}}.table-options{background:#fff;padding:1.5rem 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
